import Field from './Field'

export default function FieldTextarea (label, key, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'input'
  this.subType = 'textarea'
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldTextarea.js